export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const NAV_LINKS = [
  { id: "about", label: "About" },
  { id: "founder", label: "Founder" },
  { id: "projects", label: "Projects" },
  { id: "knights-court", label: "Case Study" },
  { id: "process", label: "Process" },
  { id: "services", label: "Services" },
  { id: "testimonials", label: "Testimonials" },
  { id: "contact", label: "Contact" },
];

export const CONTACT = {
  email: "meenugaur2000@gmail.com",
  phoneDisplay: "+91 97174 41819",
  phoneHref: "tel:+919717441819",
  address: "Sector-150, Noida, Uttar Pradesh 201304",
};

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const scrollToTop = () => {
  if (window.__lenis) window.__lenis.scrollTo(0, { duration: 1.4 });
  else window.scrollTo({ top: 0, behavior: "smooth" });
};

export const EASE = [0.22, 1, 0.36, 1];
